import { render } from "./LoadingBar.vue?vue&type=template&id=04ac9bed&bindings={\"total\":\"options\",\"isDone\":\"options\",\"progress\":\"options\",\"imageLoadHandler\":\"options\"}"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"
script.render = render

export default script